/**
 * Iconițele predefinite ale butonului de chat (bulina `.aig-toggle`) — alternativa
 * „safe" la un logo încărcat, pentru clienții al căror logo nu stă bine într-o
 * bulină de 46px: standardele pieței (bulă de chat, bulă cu puncte, semn de
 * întrebare, headset de suport), robotul prietenos și un sparkle „AI".
 *
 * Stroke pe `currentColor`, fără niciun fill fix: iconița moștenește cerneala
 * butonului (`--aig-on-primary`), deci rămâne lizibilă pe orice culoare primară
 * aleasă de client — exact regula după care trăiește și TOGGLE_MARK_SVG.
 *
 * Formele pornesc din Lucide (lucide.dev, licență ISC), ușor ajustate.
 *
 * Fișier fără zod, importabil pe subpath (`@ai-guidance/shared/presetIcons`) —
 * dashboardul îl trage fără să umfle bundle-ul, ca `brandColor`. Șirurile de mai
 * jos ajung VERBATIM în DOM-ul sitului clientului (innerHTML în shadow root):
 * niciun comentariu nu are voie ÎNĂUNTRUL lor — vezi CLAUDE.md despre template
 * strings servite ca atare.
 */

export const PRESET_TOGGLE_ICON_IDS = [
  "chat",
  "chat-dots",
  "question",
  "headset",
  "bot",
  "sparkles",
] as const;

export type PresetToggleIconId = (typeof PRESET_TOGGLE_ICON_IDS)[number];

/* 26px, ca TOGGLE_MARK_SVG — dimensiunea vine din atribute, nu din CSS, fiindcă
   în shadow root nu există stylesheet-ul dashboardului. */
const OPEN =
  '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
  'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';

const BUBBLE = '<path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/>';

export const PRESET_TOGGLE_ICONS: Record<PresetToggleIconId, string> = {
  chat: OPEN + BUBBLE + "</svg>",
  "chat-dots":
    OPEN + BUBBLE + '<path d="M8 12h.01"/><path d="M12 12h.01"/><path d="M16 12h.01"/></svg>',
  question:
    OPEN +
    BUBBLE +
    '<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>',
  headset:
    OPEN +
    '<path d="M4 14v-2a8 8 0 0 1 16 0v2"/>' +
    '<rect x="3" y="13" width="4" height="6" rx="2"/>' +
    '<rect x="17" y="13" width="4" height="6" rx="2"/>' +
    '<path d="M20 19a4 4 0 0 1-4 3h-2"/></svg>',
  bot:
    OPEN +
    '<circle cx="12" cy="3.5" r="1.1" fill="currentColor" stroke="none"/>' +
    '<path d="M12 5v3"/>' +
    '<rect x="4" y="8" width="16" height="11" rx="2.5"/>' +
    '<path d="M9 12.5v2"/><path d="M15 12.5v2"/>' +
    '<path d="M2 13.5h2"/><path d="M20 13.5h2"/></svg>',
  sparkles:
    OPEN +
    '<path d="M11.02 3.55a1 1 0 0 1 1.96 0l1.09 4.04a2 2 0 0 0 1.41 1.41l4.04 1.09a1 1 0 0 1 0 1.96l-4.04 1.09a2 2 0 0 0-1.41 1.41l-1.09 4.04a1 1 0 0 1-1.96 0l-1.09-4.04a2 2 0 0 0-1.41-1.41l-4.04-1.09a1 1 0 0 1 0-1.96l4.04-1.09a2 2 0 0 0 1.41-1.41Z"/>' +
    '<path d="M20 3v4"/><path d="M22 5h-4"/>' +
    '<path d="M4 17v2"/><path d="M5 18H3"/></svg>',
};
